import { Fragment, useEffect, useState } from "react";
import { CollapseableCard } from "../../../CommonElements";
import { Col } from "reactstrap";
import { H5 } from "../../../AbstractElements";
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import { useStaf } from "../../../Context/StafContext";

const Profil = (props) => {
  const stafAPI = useStaf();
  const [fotoURL, setFotoURL] = useState(null);
  const [groupStaf, setGroupStaf] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      if (props?.dataStaf?.foto_id) {
        const fotoRes = await stafAPI.getFotoProfilByID(props.dataStaf.foto_id);
        const url = URL.createObjectURL(fotoRes.data);
        setFotoURL(url);
      }
  
      if (props?.dataStaf?.group_staf) {
        const groupRes = await stafAPI.getGroupByID(props.dataStaf.group_staf);
        setGroupStaf(groupRes.data);
      }
    };
  
    fetchData();
  }, [props.dataStaf]);

  return (
    <Fragment>
      <Col {...props}>
        <CollapseableCard title="Profile">
          <div className="d-flex flex-column justify-content-center" style={{ height: "370px"}}>
            <div className="flex justify-center">
              <div className="relative w-16 h-16">
                <div className="absolute inset-0 rounded-full bg-blue-100 blur-sm transform scale-105"></div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  {fotoURL ? (
                    <div 
                      onClick={() => setIsOpen(true)} 
                      style={{ cursor: 'pointer' }}
                    >
                      <img
                        src={fotoURL}
                        alt={props.dataStaf?.nama || "Profile"}
                        style={{
                          width: "150px",
                          aspectRatio: "1",
                          objectFit: "cover",
                          borderRadius: "50%",
                          border: "4px solid #e3e3e3",
                        }}
                      />
                    </div>
                  ) : (
                    <div
                      style={{
                        width: "100px",
                        aspectRatio: "1",
                        borderRadius: "50%",
                        border: "4px solid #e3e3e3",
                        textAlign: "center",
                        overflow: "hidden",
                        backgroundColor: "#e3e3e3",
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 100 100"
                        style={{
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        <circle cx="50" cy="50" r="50" fill="#e3e3e3" />
                        <circle cx="50" cy="35" r="18" fill="#a0aec0" />
                        <path
                          d="M50 60 C20 60 15 90 15 100 L85 100 C85 90 80 60 50 60"
                          fill="#a0aec0"
                        />
                      </svg>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="text-center mt-4">
              <H5 className="text-xl font-semibold mb-2">
                {props.dataStaf?.nama || "Loading..."}
              </H5>
              <p className="text-gray-600">{groupStaf?.nama}</p>
            </div>
          </div>
        </CollapseableCard>
      </Col>

      {isOpen && fotoURL && (
        <Lightbox
          mainSrc={fotoURL}
          onCloseRequest={() => setIsOpen(false)}
          enableZoom={true}
        />
      )}
    </Fragment>
  );
};

export default Profil;